let accordions = document.querySelectorAll('[data-accordion]');

accordions.forEach((button) => {
    let accordionBody = button.nextElementSibling;

    button.addEventListener('click', function () {
        let isOpen = accordionBody.style.maxHeight;

        // Chiudi tutti gli accordion
        accordions.forEach((otherButton) => {
            let otherBody = otherButton.nextElementSibling;
            otherBody.style.maxHeight = null;
            otherButton.removeAttribute('data-accordion-open');
        });

        // Se l'accordion cliccato era chiuso, aprilo
        if (!isOpen) {
            accordionBody.style.maxHeight = accordionBody.scrollHeight + 'px';
            button.setAttribute('data-accordion-open', '');
        }
    });
});
